import { Component, OnInit } from '@angular/core';
import {DialogService} from '../../services/dialog.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  public errorMessage;
  constructor(private dialogService: DialogService) {
    this.errorMessage = this.dialogService.errorMessage;
  }

  ngOnInit(): void {
  }

}
